import React from 'react';
import {Card, CardBody} from 'reactstrap';
import {withTranslation} from 'react-i18next';

const IconCard = ({className = 'mb-4', icon, title, value, t}) => {
  return (
    <div className={`icon-row-item ${className}`} style={{direction: 'ltr'}}>
      <Card>
        <CardBody className="d-flex flex-1 flex-column align-items-center justify-content-center">
          <span style={{fontSize: 30}}>
            <i className={`${icon} font-weight-semibold`}/>
          </span>
          <span className="font-weight-semibold mb-5 mt-3">
            {t(title)}
          </span>
          <span className="text-large text text-primary font-weight-semibold" style={{direction: 'rtl'}}>{value}</span>
        </CardBody>
      </Card>
    </div>
  );
};

export default withTranslation()(IconCard);
